import { MacroRegion } from "enum/MacroRegion";
import { IStation } from "stores/data/oceanWeatherIntelligences/oceanWeatherIntelligenceModel";

export const createCustomPoint = (
    lat: number,
    lon: number,
    macroRegion: MacroRegion
): IStation => {
    return {
        station_id: 0,
        station_name: `${lat.toFixed(4)}, ${lon.toFixed(4)}`,
        station_lat: lat,
        station_lon: lon,
        station_depth: 0,
        station_depth_unit: "m",
        station_save_by_user: false,
        macro_region_origin: macroRegion,
    };
};
